import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { GameStatisticsService } from 'src/app/shared/game-statistics.service';
import { PlayerViewInData } from '../config-set-stats-player-view-dialog/config-set-stats-player-view-dialog.component';
import { GameAssessmentService } from 'src/app/shared/game-assessment.service';
import { GameAssessmentViewModel, UpdateGameAssessmentModel } from 'src/app/load/models/EventModels';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-config-set-gameassessment-dialog',
    templateUrl: './config-set-gameassessment-dialog.component.html',
    styleUrls: ['./config-set-gameassessment-dialog.component.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, ReactiveFormsModule, FormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatDialogActions, MatButton]
})
export class ConfigSetGameassessmentDialogComponent implements OnInit {

  _teamId: string;
  gameassessments: GameAssessmentViewModel[];
  GameAssessmentId: string;

  constructor(
    public gaService: GameAssessmentService,     
    public dialogRef: MatDialogRef<ConfigSetGameassessmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InData
  )
  { 

      this._teamId = data.TeamId;
      //console.log(this._teamId);

  }

  ngOnInit(): void {
    this.gaService.getAll().subscribe(gas=>{
      this.gameassessments= gas as GameAssessmentViewModel[];
    });
  }


  onCloseConfirm() {
    this.dialogRef.close(
      this.GameAssessmentId
    );   
  }

  onNoClick(): void {
   this.dialogRef.close();
  }

  change(event)
  {
    if(event.isUserInput) {
      //console.log(event.source.value, event.source.selected);
      this.GameAssessmentId= event.source.value;
      console.log(this.GameAssessmentId);
    }
  }


}


class InData{
  TeamId: string;
}
